
// Default skin - styles from audiblepresents-front
const defaultSkin = {
  name: 'default',
  colors: {
    primary: '#007bff',
    secondary: '#6c757d',
    accent: '#28a745',
    background: '#ffffff',
    text: '#212529',
    red: '#dc3545',
    grey: '#e9ecef',
    grey2: '#ced4da'
  },
  button: {
    background: '#f8f9fa',
    hover: {
      textDecoration: 'underline',
    },
    disabled: {
      background: '#eee',
      color: '#ccc',
      opacity: '0.5',
    }
  },
  layout: {
    container: {
      top: '0',
      height: '100%'
    },
    main: {
      height: '100%'
    }
  },
  mainLayout: {
    container: {
      backgroundColor: '#fafafa',
      height: '100%',
      width: '100%',
      margin: 'auto 0',
      display: 'flex',
      flexFlow: 'column'
    },
    topContent: {
      padding: '0 2.8rem',
      borderBottom: '0.1rem solid #ced4da'
    },
    mainContent: {
      position: 'relative',
      overflow: 'hidden'
    },
    content: {
      padding: '2.8rem',
      height: '100%'
    }
  },
  form: {
    input: {
      width: '100%',
      padding: '0.8rem 0 0.8rem 1rem',
      border: '1px solid #ced4da',
      borderRadius: '0.25rem',
      hover: {
        border: '1px black solid'
      },
      focus: {
        outline: 'none',
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)'
      },
      disabled: {
        background: '#555'
      }
    },
    textarea: {
      width: '100%',
      height: '12rem',
      padding: '0.8rem 1.2rem',
      border: '1px solid #ced4da',
      borderRadius: '0.25rem'
    },
    row: {
      margin: '0 0 1.5rem'
    },
    form: {
      maxWidth: '32rem',
      marginBottom: '3rem'
    }
  },
  spinner: {
    size: '24px',
    width: '2px',
    borderColor: '#007bff',
    duration: '1s'
  },
  animatedButton: {
    width: '200',
    height: '100',
    borderRadius: '10',
    backgroundColor: 'rgba(0, 123, 255, 0.2)',
    textColor: 'white',
    text: 'Click Me',
    layers: 5,
    animation: {
      baseSpeed: 1000,
      minAngle: '-10deg',
      maxAngle: '10deg'
    }
  },
  bristleBrush: {
    width: 400,
    height: 400,
    stroke: '#456837',
    strokeWidth: 30,
    defaultOpacity: 1,
    gradient: {
      startColor: '#000000',
      endColor: '#FFFFFF'
    },
    filters: {
      softEdge: {
        enabled: true,
        blur: 3
      },
      bristle: {
        enabled: true,
        baseFrequency: 0.5,
        numOctaves: 2,
        scale: 10
      }
    },
    path: {
      d: 'M 50 150 Q 150 50 250 150 T 450 150'
    }
  },
  components: {}
};

export default defaultSkin;
